import React from 'react';
import { Typography } from '@mui/material';
import { toast } from 'react-toastify';

export default (header, body, render = true, type = 'warning') => {
  const content = (
    <div>
      {header}
      <Typography variant="caption" component="p">
        {body}
      </Typography>
    </div>
  );

  if (render) {
    switch (type) {
      case 'success':
        toast.success(() => content);
        break;
      case 'error':
        toast.error(() => content);
        break;
      default:
        toast.warning(() => content);
        break;
    }
  }
};
